import { render, staticRenderFns } from "./CloudSaveMessage.vue?vue&type=template&id=2a606da6&scoped=true"
import script from "./CloudSaveMessage.vue?vue&type=script&lang=js"
export * from "./CloudSaveMessage.vue?vue&type=script&lang=js"
import style0 from "./CloudSaveMessage.vue?vue&type=style&index=0&id=2a606da6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a606da6",
  null
  
)

export default component.exports